module.exports = __webpack_public_path__ + "static/media/civ-eng.bc722631.jpg";